import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue"
  import NativeButton from "./nativeButton.vue"
  import { RouterLink } from "vue-router"
  interface Props {
    nativeType?: "button" | "submit" | "reset"
    disabled?: boolean
    to?: string
    textCenter?: boolean
    type?: "primary" | "default" | "danger" | "outline-danger" | "outline-primary" | "flat" | "flat-primary" | "link" | "link-plain"
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'buttonTemplate',
  props: {
    nativeType: null,
    disabled: { type: Boolean },
    to: null,
    textCenter: { type: Boolean },
    type: null
  },
  setup(__props: any) {

const props = __props as {
    nativeType?: "button" | "submit" | "reset"
    disabled?: boolean
    to?: string
    textCenter?: boolean
    type?: "primary" | "default" | "danger" | "outline-danger" | "outline-primary" | "flat" | "flat-primary" | "link" | "link-plain"
  }

  
  const nativeType = computed(() => props.nativeType || "button")
  const type = computed(() => props.type || "default")
  const to = computed(() => props.to || "")
  const textCenter = computed(() => (typeof props.textCenter !== "boolean" ? true : props.textCenter))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(to).length ? _unref(RouterLink) : NativeButton), {
    to: _unref(to),
    type: _unref(nativeType),
    disabled: props.disabled,
    class: _normalizeClass(["h-[45px] px-5 rounded-[10px] transition duration-150 ease-in-out hover:translate-y-1", {
      'font-[500] drop-shadow-xl bg-primary-violet text-white border-0 border-primary-violet hover:text-primary-violet hover:bg-white hover:border-white': _unref(type) == 'primary',
      'font-[500] drop-shadow-xl bg-white text-primary-violet hover:bg-primary-violet hover:text-white': _unref(type) == 'default',
      'font-[500] drop-shadow-xl bg-error text-white border-0 border-error hover:text-error hover:bg-white': _unref(type) == 'danger',
      'font-[500] drop-shadow-xl bg-white text-error border-0 border-error hover:bg-error hover:text-white': _unref(type) == 'outline-danger',
      'font-[500] drop-shadow-xl bg-white text-primary-violet border-0 border-primary-violet hover:bg-primary-violet hover:text-white': _unref(type) == 'outline-primary',
      'font-[500] bg-white text-primary-violet hover:bg-primary-violet hover:text-white': _unref(type) == 'flat',
      'font-[500] bg-primary-violet text-white border-0 border-primary-violet hover:text-primary-violet hover:bg-white hover:border-white': _unref(type) == 'flat-primary',
      'font-[500] text-base font-bold text-primary-black hover:text-primary-violet transition ease-in-out duration-150 hover:underline hover:underline-offset-8 hover:decoration-2 rounded-md':
        _unref(type) == 'link',
      'text-base text-primary-black hover:text-primary-violet transition ease-in-out duration-150': _unref(type) == 'link-plain',
      'opacity-50': props.disabled,
      'flex items-center': _unref(to).length,
      'text-center justify-center': _unref(textCenter),
    }])
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["to", "type", "disabled", "class"]))
}
}

})